import styled, { css } from 'styled-components'

export const oLStyles = css``

type OLProps = {}
export const OL = styled.ol<OLProps>`
	${oLStyles}
`
